import Button from "@/components/Common/Buttons/Button/Button.vue";
import ModalCloseBtn from "@/components/Modal/ModalCloseBtn.vue";
import InputField from '@/components/Common/Inputs/Input/Input.vue';
import CheckBox from '@/components/Common/Inputs/CheckBox/CheckBox.vue';
import RadioButton from '@/components/Common/Inputs/RadioButton/RadioButton.vue';
import CoinsIcon from '@/components/Common/Icons/CoinsIcon.vue';
import Modal from "@/components/Modal/Modal.vue";
import {toCurrency} from "@/utils/currency.js";

export default {
    name: 'CreditBuyModal',
    components: {
        Button,
        ModalCloseBtn,
        InputField,
        Modal,
        CheckBox,
        RadioButton,
        CoinsIcon
    },
    data() {
        return {
            selected: null,
            credits: [
                { credits: 4, price: 2, promo: false, },
                { credits: 9, price: 4.50, promo: false, },
                { credits: 39, price: 17.50, promo: true, },
                { credits: 58, price: 25, promo: true, },
                { credits: 86, price: 35, promo: true, },
                { credits: 132, price: 50, promo: true, },
            ]
        }
    },
    methods: {
        toCurrency,
        closeModal() {
            this.$store.dispatch("utils/closeModal", this.$props.name);
        },
        async pay() {
            if (this.selected === null) {
                return;
            }

            try {
                const response = await this.$store.dispatch("payment/initiateCreditBuy", {credits: this.selected});
                if (!response.hasOwnProperty('paymentUrl')) {
                    throw new Error('err');
                }

                const paymentUrl = response.paymentUrl;
                window.location.replace(paymentUrl);
            } catch (err) {
                await this.$store.dispatch('utils/closeModal', 'creditBuy');
                await this.$store.dispatch('utils/openNotificationModal', {
                    type: 'error',
                    message: this.$t('please-try-again-later')
                });
            }
        },
        select(id) {
            this.selected = id;
        }
    }
}